var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"light","content":"Chat de soporte","placement":"bottom"}},[_c('div',{staticClass:"btn-action border d-middle-center cr-pointer text-general",on:{"click":_vm.verChat}},[_c('i',{staticClass:"icon-message-text-outline f-14"})])]),_c('modalChat',{ref:"modalChatIcono"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }